/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
}
:host > .container > davinci-icon-ref-small {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  align-self: auto;
  cursor: pointer;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  z-index: 21;
}
:host > .container > .clear {
  fill: #B4BEC5;
  fill: var(--davinci-color-outline, #B4BEC5);
  margin-right: calc(4rem/14);
}
:host > .container > .clear.hide {
  visibility: hidden;
}
:host > .container > .clear:hover {
  fill: #697987;
  fill: var(--davinci-color-text-lighter, #697987);
}
:host > .container > .spinner {
  display: none !important;
}
:host > .container .list ::slotted(davinci-option) {
  color: #697987;
  color: var(--davinci-color-text-lighter, #697987);
}
:host > .container .list ::slotted(davinci-option:hover) {
  background-color: var(--davinci-color-background-3,#F0F3F4) !important;
}

:host([loading]) .search {
  display: none !important;
}
:host([loading]) .spinner {
  display: block !important;
}`;
export { style };
//# sourceMappingURL=SearchField.style.js.map